<template lang="html">
  <div style="position: relative; display: inline-block;"
       class="beneficiary-link-component">
    <popover :title="popoverTitle" trigger="outside-click" custom-class="beneficiary-link-popover"  v-model="showPopover">
      <template>
        <a class="beneficiary-link" ref="link" id="testId"
           @click.prevent="onClickBeneficiary" href="#">{{
            text
          }}</a>
      </template>
      <template v-slot:popover>
        <div class="">
          <div v-if="isCapitalistAccount" class="details-content-wrap">
            <div v-show="detailsLoading">{{ $t('Идет поиск...') }}</div>
            <div v-if="details && !detailsLoading && details.profile" class="user-profile-details">
              <div class="user-profile-avatar"><img :src="details.profile.avatarWeb"/></div>
              <div>{{ details.profile.nickname }}</div>
            </div>
            <div v-if="details && details.accountDetails" class="account-details">
              <div class="account-details-row">
                <div>{{ details.accountDetails.number }}</div>
                <div>{{ details.accountDetails.name }}</div>
              </div>
              <div class="account-details-row">
                <div>{{ $t('Баланс') }}</div>
                <div>{{
                    details.accountDetails.availBalance | moneyFormat(details.accountDetails.currency)
                  }} {{ details.accountDetails.currency }}
                </div>
              </div>
            </div>
            <div v-show="!details && !detailsLoading && errorMessage">{{ errorMessage }}</div>
          </div>
          <div class="beneficiary-details-popover text-center">
            <a :href="searchUrl" class="btn btn-success">{{ $t('Поиск по корреспонденту') }}</a>
          </div>
        </div>
      </template>
    </popover>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import axios from 'axios';
import {Popover} from 'uiv';
import {formatUnixDateFilter} from '@/models/filters/datetime';
import {MoneyFormatFilter} from '@/models/filters/money';
// import Popover from 'vue-js-popover';

// Vue.use(uiv);
// Vue.use(Popover);

@Component({
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
  },
  components: {
    popover: Popover
  },
  name: 'history-document-beneficiary-link',
})
export default class DocumentBeneficiaryLink extends Vue {
  @Prop({default: null})
  beneficiary?: string | null

  @Prop({default: null})
  searchLink?: string | null

  @Prop({default: true})
  isCapitalistBeneficiary!: boolean

  popoverId = `popover-${new Date().getTime()}${Math.random()}`

  get targetEl() {
    return this.$refs.link as HTMLElement;
  }

  showPopover = false

  detailsLoaded = false

  detailsLoading = true

  details: any = null

  lazyLoading = false

  errorMessage: any = null

  onClickEl() {
    return;
  }

  get popoverTarget() {
    return this.$refs.link;
  }

  get searchUrl(): string {
    return this.searchLink as string;
  }

  transitionComplete() {
    return;
  }

  get isYourAccount(): boolean {
    return (this.details && this.details.accountDetails);
  }

  get popoverTitle(): string {
    return this.text + (this.isYourAccount ? ` - ${'ваш аккаунт'}` : '');
  }

  get text(): string {
    return this.beneficiary as string;
  }

  get isCapitalistAccount(): boolean {
    if (!this.beneficiary) return false;

    if (this.beneficiary.match(/^[a-z]\d{7,}$/) && this.isCapitalistBeneficiary) {
      return true;
    }

    return false;
  }

  get popoverClass(): any {
    return ''; // this.showPopover ? 'in open' : ''; // fade
  }

  get popoverStyle(): any {
    if (!this.showPopover) return {};

    const linkWidth = (this.$refs.link as any).offsetWidth as number;
    const popoverWidth = (this.$refs.popover as any).offsetWidth as number;

    return {
      // display: 'block',
      top: 'auto',
      bottom: '100%',
      left: `${(linkWidth - popoverWidth) / 2}px`,
      marginBottom: '10px',
    };
  }

  onClickBeneficiary(e): any {
    // console.log(this.showPopover)

    if (this.showPopover)
      e.stopPropagation();

    this.showPopover = true;

    this.onPopoverShow();

    return {propa: 'gate'};
  }

  onPopoverShow(): any {
    if (!this.lazyLoading) {
      this.lazyLoading = true;

      if (this.isCapitalistAccount) {
        axios.post('/webapi/finance/beneficiarydetails', {
          account: this.beneficiary,
          call: 'details',
        }).then((result: any) => {
          if (result.data.success) {
            this.details = result.data.details;
          } else {
            this.errorMessage = result.data.message ? result.data.message : this.$t('Не удалось загрузить данные, попробуйте позже.');
          }

          this.detailsLoading = false;
        }, () => {
          this.errorMessage = this.$t('Не удалось загрузить данные, попробуйте позже.');
          this.detailsLoading = false;
        });
      }
    }

    return {propa: 'gate'};
  }
}
</script>

<style scoped lang="less">
.beneficiary-link {
  cursor: pointer;
  cursor: hand;
}
</style>

<i18n>
{
  "en": {
    "Поиск по корреспонденту": "Search by correspondent",
    "Идет поиск...": "Searching...",
    "ваш аккаунт": "your account",
    "Баланс": "Balance",
    "Не удалось загрузить данные, попробуйте позже.": "Failed to load data, try again later."
  }
}
</i18n>
